import {useSelector} from "react-redux";
import {HeaderMenu} from "./HeaderMenu";

export const BoardPageHeader = ({isChangeBoardText, setIsChangeBoardText, handleChangeBoardName, menuRef, setIsMenuOpen, isMenuOpen, handleOpenActionModal, handleArchiveItems, handleArchiveCards}) => {
    const activeBoard = useSelector(state => state.boards.activeBoard);
    const user = useSelector(state => state.user.user);

    const userRole = activeBoard?.rbac?.find(
        (el) => el.user_id === user?.id
    )?.role;

    return (
        <div className="boardPage__header">
            {!isChangeBoardText ? (
                <span
                    className="boardPage__title"
                    onClick={() => userRole !== 1 && setIsChangeBoardText(true)}
                >
                        {activeBoard?.name}
                    </span>
            ) : (
                <input
                    className="boardTitleInput"
                    type="text"
                    autoFocus
                    defaultValue={activeBoard?.name}
                    onBlur={() => setIsChangeBoardText(false)}
                    onKeyDown={handleChangeBoardName}
                />
            )}

            <div className="boardMenu" ref={menuRef}>
                <button
                    type="button"
                    className="boardMenu__button"
                    onClick={() => setIsMenuOpen((prev) => !prev)}
                >
                    ⋮
                </button>

                <HeaderMenu isMenuOpen={isMenuOpen} handleOpenActionModal={handleOpenActionModal} handleArchiveItems={handleArchiveItems} handleArchiveCards={handleArchiveCards}/>
            </div>
        </div>
    )
}